module.exports = __webpack_public_path__ + "96eed4e0e39adc9cba9c925fe19b77de.MP3";